import * as React from 'react'
import { useRef } from 'react'
import { useDispatch } from 'react-redux'

import Popup from '../../../ui/popup'
import Button from '../../../ui/button'

import Cropper from 'react-cropper'

import { ReactCropperProps } from 'react-cropper'

import { avatarUpload } from '../../../../store/member/memberSlice'
import 'cropperjs/dist/cropper.css'

interface Props {
    onClose: () => void
    file: string | null
}

const AvatarPopup: React.FunctionComponent<Props> = ({ file, onClose }: Props) => {
    const dispatch = useDispatch()

    const cropperRef = useRef<HTMLImageElement>(null)

    const upload = () => {
        const imageElement: HTMLImageElement & { cropper?: ReactCropperProps } = cropperRef.current
        const cropper: ReactCropperProps = imageElement.cropper
        // @ts-ignore
        dispatch(avatarUpload({ image_data: cropper.getCroppedCanvas().toDataURL() }))
        onClose()
    }

    return (
        <Popup
            onClose={onClose}
            classname="vertical"
            title="Change avatar"
            buttons={
                <>
                    <Button type="button" onClick={() => upload()} label="Save" />
                    <Button type="button" secondary onClick={onClose} label="Cancel" />
                </>
            }
            profile={true}
        >
            <Cropper src={file} className="cropper" initialAspectRatio={4 / 3} ref={cropperRef} />
        </Popup>
    )
}

export default AvatarPopup
